import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error occurred:', error, 'Error info:', errorInfo)
    // You can log the error or send it to an error tracking service here
    this.setState({ errorInfo })
  }

  componentDidUpdate(prevProps) {
    // If the children props have changed, reset the error state
    if (this.props.children !== prevProps.children) {
      this.setState({ hasError: false, error: null, errorInfo: null })
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render a fallback UI for the error state
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '24px',
            fontWeight: 'bold',
            color: 'red'
          }}
        >
          <h1>Something went wrong.</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            {this.state.error && this.state.error.toString()}
            <br />
          </details>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
